export default __webpack_public_path__ + "static/Principle-scale-dark-3c8135a590b2fa3391eb947ca6d26248.png";